import Modal from 'react-modal'
import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'
import { MOBILE_FLOOR_MAP_UNAVAILABLE_MESSAGE } from '../../../utils/mobileFloorMapAvailability'

const modalStyles: {
  overlay: React.CSSProperties
  content: React.CSSProperties
} = {
  overlay: {
    position: 'fixed',
    zIndex: 1200,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  },
  content: {
    position: 'relative',
    inset: 'unset',
    border: 'none',
    background: 'transparent',
    overflow: 'visible',
    padding: 0,
    width: 'auto',
    maxWidth: 'none',
    maxHeight: 'none',
  },
}

interface MobileFloorMapUnavailableModalProps {
  isOpen: boolean
  onClose: () => void
}

export const MobileFloorMapUnavailableModal = ({
  isOpen,
  onClose,
}: MobileFloorMapUnavailableModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Feature unavailable on mobile"
      style={modalStyles}
      aria={{ labelledby: 'mobile-floor-map-unavailable-title' }}
    >
      <ModalCard>
        <ModalHeader>
          <ModalTitle id="mobile-floor-map-unavailable-title">
            Feature unavailable
          </ModalTitle>
          <CloseButton type="button" onClick={onClose} aria-label="Close">
            <CloseIcon viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path
                d="M11.7674 10.0002L19.6338 2.13472C20.1221 1.64642 20.1221 0.854731 19.6338 0.366469C19.1455 -0.121831 18.3538 -0.121831 17.8655 0.366469L9.99997 8.23279L2.13447 0.366469C1.64617 -0.121831 0.854487 -0.121831 0.366225 0.366469C-0.122036 0.85477 -0.122075 1.64646 0.366225 2.13472L8.23254 10.0002L0.366225 17.8658C-0.122075 18.3541 -0.122075 19.1457 0.366225 19.634C0.854526 20.1223 1.64621 20.1223 2.13447 19.634L9.99997 11.7676L17.8655 19.634C18.3538 20.1223 19.1455 20.1223 19.6337 19.634C20.122 19.1457 20.122 18.354 19.6337 17.8658L11.7674 10.0002Z"
                fill="currentColor"
              />
            </CloseIcon>
          </CloseButton>
        </ModalHeader>
        <ModalBody>{MOBILE_FLOOR_MAP_UNAVAILABLE_MESSAGE}</ModalBody>
        <ModalFooter>
          <OkButton type="button" onClick={onClose}>
            OK
          </OkButton>
        </ModalFooter>
      </ModalCard>
    </Modal>
  )
}

const ModalCard = styled.div`
  width: 360px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border-radius: 2px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.25);
  overflow: hidden;

  @media ${media.belowTablet} {
    width: 100%;
    max-width: 400px;
  }
`

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 12px 12px 16px;
  background: #ffffff;
  border-bottom: 1px solid #e8eaed;
`

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 600;
  color: #073c7a;
`

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 8px;
  margin: 0;
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  color: #7e858e;
`

const CloseIcon = styled.svg`
  width: 16px;
  height: 16px;
  display: block;
`

const ModalBody = styled.p`
  margin: 0;
  padding: 20px 16px;
  font-size: 15px;
  line-height: 1.45;
  color: #7e858e;
  background: #ffffff;
`

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 16px 16px;
  background: #ffffff;
`

const OkButton = styled.button`
  cursor: pointer;
  padding: 10px 20px;
  min-height: 44px;
  min-width: 88px;
  color: #ffffff;
  background: #073c7a;
  border: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;

  &:hover {
    background: #052d5c;
  }
`
